import {AbstractDraw, DrawInteractionState} from "./abstract-draw";
import {MapMouseEvent} from "@mapbox/mapbox-gl-draw";
import {Position, Feature, Point, MultiPoint} from "geojson";
import {GeometryUtil} from "../geometry";
import {v4 as uuid} from 'uuid';

export abstract class AbstractDrawPoint extends AbstractDraw<DrawInteractionState> {
    protected point: Feature<Point> | undefined;

    async onClick(state: DrawInteractionState, e: MapMouseEvent) {
        let snapPoint = await this._getSnapPoint(state, e);
        if (!this.controller.interaction.hasManualInputDialog()) {
            this.aim.geometry.coordinates = snapPoint.point as Position;
            this.displayDrawFeature(this.aim);
            this.save(state);
        }
        else {
            await super.setCoordinates(state, [...state.vertexList, snapPoint.point]);
            this._generateManualInputPoints(state);
            this.tick();
        }
    }


    isManualInputSupported(state: DrawInteractionState): boolean {
        return true;
    }

    canSave(state: DrawInteractionState): boolean {
        return state.vertexList.length > 0;
    }

    async setCoordinates(state: DrawInteractionState, points: Position[]): Promise<void> {
        if (!this.controller.interaction.hasManualInputDialog()) {
            this.aim.geometry.coordinates = points[0];
            this.displayDrawFeature(this.aim);
            this.save(state, undefined);
        }
        else {
            this.clearDrawFeatures();
            await super.setCoordinates(state, points);
            this._generateManualInputPoints(state);
            this.tick();
        }
    }

    save(state: DrawInteractionState, nextInteraction: string | undefined = undefined): void {
        if (state.vertexList.length > 0)
            this.createLayerGeometries(
                [...state.vertexList.map(x => GeometryUtil.point(x))],
                nextInteraction
            )
        else
            this.createLayerGeometries(
                [GeometryUtil.point(this.aim.geometry.coordinates)],
                nextInteraction
            )
    }

    protected _generateManualInputPoints(state: DrawInteractionState): void {
        state.vertexList.forEach((point: Position, index) => {
            let p = this.createIcon(point, 'auto-aim', {
                id: `tmp_point_${index}`
            });
            this.displayDrawFeature(p);
        })
    }
}
